import { render } from "./LoaderComponent.vue?vue&type=template&id=34c7e416&ts=true"
import script from "./LoaderComponent.vue?vue&type=script&lang=ts"
export * from "./LoaderComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__